import { hotspotHexagonColorRange } from "../layers/hotspots/constants"
import { useElevationReadout } from "./useElevationReadout"

export const FireDangerUSVisual = () => (
    <div
        className="w-full rounded-[16px]"
        style={{
            height: 6,
            background:
                "linear-gradient(90deg, #929694 0%, #70719E 20%, #839CC5 40%, #9EC5CD 60%, #D1DAA8 80%, #DCC289 100%)",
        }}
    />
)

const fireDangerCAColors = ["#8080B9", "#89B083", "#D4D4A1", "#B58A62", "#B88482"]

export const FireDangerCAVisual = () => (
    <div className="w-full flex gap-1" style={{ height: 19 }}>
        {fireDangerCAColors.map((color) => (
            <div key={color} className="flex-1 rounded-[6px]" style={{ backgroundColor: color }} />
        ))}
    </div>
)

export const HeatVisual = () => (
    <div
        className="w-full rounded-[12px]"
        style={{
            height: 6,
            background:
                "linear-gradient(90deg, #F19D59 0%, #F28B4C 24%, #F0592D 64%, #F14221 100%)",
        }}
    />
)

export const HotspotTemperatureVisual = () => (
    <div className="w-full flex justify-between">
        {hotspotHexagonColorRange.map((color, i) => (
            <div
                key={i}
                className="h-5 w-5 rounded-[6px]"
                style={{ backgroundColor: `rgb(${color.join(",")})` }}
            />
        ))}
    </div>
)

const hotspotBarSizesInRem = [0.5, 1, 1.5, 2, 2.5]

export const HotspotAreaVisual = () => (
    <div className="w-full flex gap-1 items-end">
        {hotspotBarSizesInRem.map((size, i) => (
            <div
                key={i}
                className="bg-gray-700 border border-white-200 rounded-t-md flex-1"
                style={{ height: `calc(${size}rem)` }}
            />
        ))}
    </div>
)

const imageOverlapColors = [
    "#FC3C2B",
    "#FD4D2D",
    "#FF6230",
    "#FF7533",
    "#FF8935",
    "#FB9E37",
    "#F7B239",
    "#B5BF3C",
    "#53C143",
    "#3BD824",
]

export const ImageOverlapVisual = () => (
    <div className="w-full flex justify-between">
        {imageOverlapColors.map((color) => (
            <div key={color} className="h-5 w-5 rounded-[6px]" style={{ backgroundColor: color }} />
        ))}
    </div>
)

export const ElevationVisual = () => {
    const elevationRef = useElevationReadout()
    return (
        <div className="w-full">
            <div className="flex justify-end mb-1">
                <small ref={elevationRef} className="mono text-gray-200 invisible">
                    0 m
                </small>
            </div>
            <svg
                className="w-full h-auto block"
                viewBox="0 0 244 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 38.0002L242 2.00024"
                    stroke="url(#elevationLegendGradient)"
                    strokeWidth="4"
                    strokeLinecap="round"
                />
                <defs>
                    <linearGradient
                        id="elevationLegendGradient"
                        x1="2"
                        y1="2.00024"
                        x2="242"
                        y2="2.00024"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#5DCAA5" />
                        <stop offset="0.5" stopColor="#EF9F27" />
                        <stop offset="1" stopColor="#A9968F" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    )
}
